module.exports = __webpack_public_path__ + "media/Video_jadid.9dd5a2a6.mp4";